var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 97,
    viewBox: "0 0 80 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 55H35V41.25H45V55H55V31.25L40 21.25L25 31.25V55ZM40 96.625C38.8333 96.625 37.6667 96.4167 36.5 96C35.3333 95.5833 34.2917 94.9583 33.375 94.125C27.9583 89.125 23.1667 84.25 19 79.5C14.8333 74.75 11.355 70.1467 8.565 65.69C5.775 61.2333 3.65 56.9417 2.19 52.815C0.730001 48.6883 0 44.75 0 41C0 28.5 4.02167 18.5417 12.065 11.125C20.1083 3.70833 29.42 0 40 0C50.58 0 59.8933 3.70833 67.94 11.125C75.9867 18.5417 80.0067 28.5 80 41C80 44.75 79.2717 48.6883 77.815 52.815C76.3583 56.9417 74.2333 61.2333 71.44 65.69C68.6467 70.1467 65.1667 74.75 61 79.5C56.8333 84.25 52.0417 89.125 46.625 94.125C45.7083 94.9583 44.6667 95.5833 43.5 96C42.3333 96.4167 41.1667 96.625 40 96.625Z",
    fill: "#7C8C52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocacion);
export default __webpack_public_path__ + "static/media/ic_locacion.ad3310b425d12d9aeefc35af7f5adb6c.svg";
export { ForwardRef as ReactComponent };